import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-196HYFHX19";
let isInitialized = false;

// Helper to push to dataLayer for Consent Mode
const gtag = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
};

export const initGA = (consentSettings = null) => {
    if (isInitialized) return;

    if (MEASUREMENT_ID && MEASUREMENT_ID !== "G-XXXXXXXXXX") {
        // 1. Set default consent (before initialization)
        // If no settings provided yet, default to all denied for privacy
        gtag('consent', 'default', {
            'analytics_storage': consentSettings?.analytics ? 'granted' : 'denied',
            'ad_storage': consentSettings?.marketing ? 'granted' : 'denied',
            'ad_user_data': consentSettings?.marketing ? 'granted' : 'denied',
            'ad_personalization': consentSettings?.marketing ? 'granted' : 'denied',
            'wait_for_update': 500
        });

        // 2. Initialize GA4
        ReactGA.initialize(MEASUREMENT_ID);
        isInitialized = true;

        // Log initial page view
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    } else {
        console.warn("Google Analytics Measurement ID is missing or is a placeholder.");
    }
};

export const updateConsent = (settings) => {
    gtag('consent', 'update', {
        'analytics_storage': settings.analytics ? 'granted' : 'denied',
        'ad_storage': settings.marketing ? 'granted' : 'denied',
        'ad_user_data': settings.marketing ? 'granted' : 'denied',
        'ad_personalization': settings.marketing ? 'granted' : 'denied'
    });
};

export const logPageView = (path) => {
    if (isInitialized) {
        ReactGA.send({ hitType: "pageview", page: path || window.location.pathname });
    }
};

export const trackEvent = (category, action, label, value) => {
    if (isInitialized) {
        ReactGA.event({
            category: category,
            action: action,
            label: label,
            value: value,
        });
    }
};
